/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Bid_DecreaseInputs */

const en_directory_vibebids_bid_decrease = /** @type {(inputs: Directory_Vibebids_Bid_DecreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease bid by one dollar`)
};

const zh_directory_vibebids_bid_decrease = /** @type {(inputs: Directory_Vibebids_Bid_DecreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将出价降低 1 美元`)
};

/**
* | output |
* | --- |
* | "Decrease bid by one dollar" |
*
* @param {Directory_Vibebids_Bid_DecreaseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_bid_decrease = /** @type {((inputs?: Directory_Vibebids_Bid_DecreaseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Bid_DecreaseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_bid_decrease(inputs)
	return zh_directory_vibebids_bid_decrease(inputs)
});
export { directory_vibebids_bid_decrease as "directory.vibebids.bid_decrease" }